import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling, regularThenResponseError } from '@src/utils';
import { licenseActions } from '@src/store/reducers/licenseReducer';

export const createLicenseMiddleware = (http: any, translate: any, successPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [licenseActions.UPLOAD_LICENSE]: async (action: any) => {
            let response: any;
            try {
                const upload = action.payload.uploadObject;
                response = await upload.upload({
                    url: `${restServiceUrl}License/UploadFile`,
                    data: { file: action.payload.file }
                });
                const licenseUploadText = await translate('LICENSE_UPLOAD');
                const licenseUploadedText = await translate('LICENSE_UPLOADED');
                const messageObj = { message: licenseUploadText, text: licenseUploadedText };
                successPopUp(messageObj);
                action.payload.onResult();
            } catch (error) {
                regularThenResponseError(action, response);
            }
        },
        [licenseActions.GET_CURRENT_LICENSE]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}License/Details`);
                next({ type: licenseActions.SET_CURRENT_LICENSE, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [licenseActions.GET_LICENSE_WARNINGS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Users/Warnings`);
                next({ type: licenseActions.SET_LICENSE_WARNINGS, payload: response.data });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/license.middleware.ts